import { InputNumber } from "antd";

export const MoneyField = ({
  prefix = "R$",
  precision = 2,
  min = 0,
  placeholder = "Digite o valor",
  thousandSeparator = ".",
  decimalSeparator = ",",
  ...restProps
}) => {
  const formatter = (val) => {
    if (!val && val !== 0) return "";

    return Number(val).toLocaleString("pt-BR", {
      maximumFractionDigits: precision,
    });
  };

  const parser = (displayValue) => {
    if (!displayValue) return "";

    const cleanValue = displayValue.replace(
      new RegExp(`${prefix}\\s?`, "g"),
      "",
    );

    const numericValue = cleanValue
      .replace(new RegExp(`\\${thousandSeparator}`, "g"), "")
      .replace(decimalSeparator, ".");

    return parseFloat(numericValue) || 0;
  };

  return (
    <InputNumber
      prefix={prefix}
      precision={precision}
      min={min}
      placeholder={placeholder}
      formatter={formatter}
      parser={parser}
      {...restProps}
    />
  );
};
